<template>
	<div class="wrapper">
		<article class="weui-article">
			<section>
				<p>请填写16位停车券密码</p>
			</section>
		</article>
		<div ref="codeForm" class="weui-form-area">
			<div class="weui-cells weui-cells_form">
				<div class="weui-cell weui-cell_vcode">
					<div class="weui-cell__hd">
						<label class="weui-label">密码</label>
					</div>
					<div class="weui-cell__bd">
						<input class="weui-input" type="tel" maxlength="16" v-model.trim="form.couponKey"
							   required notMatchTips="请输入正确的密码" emptyTips="请输入16位停车券密码" placeholder="16位停车券密码">
					</div>
				</div>
			</div>
			<div class="weui-btn-area">
				<button class="weui-btn weui-btn_primary" @click="handleBind">立即绑定</button>
			</div>
		</div>
		<div class="weui-btn-area">
			<button class="weui-btn weui-btn_warn" @click="handleScanBind">扫码绑定</button>
		</div>
	</div>
</template>

<script>
    import { getScanConfig } from "../../../api/coupon/personalBind";
    import { userGetCoupon } from "../../../api/coupon/userGetCoupon";
    import { mapGetters } from 'vuex'
    import base from "@/api/base";
    import { LocationManager } from "@/utils/LocationManagerUrl"

    export default {
        name: "index",
        data () {
            return {
                baseHttps: base.https,
                baseHttp: base.http,
                baseUrl: base.url + "/",
                form: {
                    bindMethod: 5,
                }
            }
        },
        computed: {
            ...mapGetters(['userOpenid','userPhone'])
        },
        mounted () {
            let form ={
                url: location.href.split("#")[0],
            };
            getScanConfig(form).then(res =>{
                if (res.code == 200) {
                    wx.config({
                        debug: false,
                        appId: res.data.appId, // 必填,公众号的唯一标识
                        timestamp: res.data.timestamp, // 必填,生成签名的时间戳
                        nonceStr: res.data.nonceStr, // 必填,生成签名的随机串
                        signature: res.data.signature, // 必填,签名
                        jsApiList: ['scanQRCode'] // 必填,需要使用的JS接口列表
                    });
                }
            })
        },
        methods: {
            /*获取微信扫码配置**/
            getScanConfig () {
                wx.ready(() => {
                    // config信息验证成功后会执行ready方法,所有接口调用都必须在config接口获得结果之后
                    // config 是一个客户端的异步操作,所以如果需要在页面加载时调用相关接口,
                    // 则须把相关接口放在ready函数中调用来确保正确执行.对于用户触发时才调用的接口,则可以直接调用,不需要放在ready函数中
                    wx.checkJsApi({ // 判断当前客户端版本是否支持指定JS接口
                        jsApiList: [
                            'scanQRCode'
                        ],
                        success: res => { // 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}
                            if (res.checkResult.scanQRCode === true) {
                                console.log('checkResult成功')
                                wx.scanQRCode({ // 微信扫一扫接口
                                    desc: 'scanQRCode desc',
                                    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                                    scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
                                    success: res => {
                                        const getCode = res.resultStr;// 当needResult 为 1 时，扫码返回的结果
                                        if (getCode.indexOf('isGZH') != -1){
                                            console.log("11111111111");
                                            LocationManager("/weChat/scanResult?" + getCode.split('?')[1])
                                        }else {
                                            console.log("22222222");
                                            LocationManager("/weChat/scanResult?" + getCode)
                                        }
                                    },
                                    fail: res =>{
                                        this.$weui.alert('扫码调用失败',res)
                                    }
                                })
                            } else {
                                this.$weui.alert('抱歉，当前客户端版本不支持扫一扫')
                            }
                        },
                        fail: res => { // 检测getNetworkType该功能失败时处理
                            this.$weui.alert('fail' + res)
                        }
                    })
                    // })
                    // }
                })
            },
            /*通过密码绑定领券**/
            handleBind () {
                let codeForm = this.$refs['codeForm'];
                this.$weui.form.validate(codeForm, error =>{
                    if (!error){
                        this.userGetCoupon();
                    }
                })
            },
            /*通过扫一扫领券**/
            handleScanBind () {
                console.log('开始扫码');
                this.getScanConfig();
                // this.$router.push({name:'toScan'})
                // location.href= "http://parkinglot.scan.easthuaxin.com/weChat/toScan"
            },
            /*调用领券接口**/
            userGetCoupon () {
                this.$set(this.form,'openid',localStorage.getItem('userOpenId')||this.userOpenid  );
                this.$set(this.form,'businessPhone',this.userPhone);
                userGetCoupon(this.form).then(res =>{
                    if (res.code == 200){
                        this.$weui.alert('成功', { title: '绑定成功' });
                    }
                })
            }
        }
    }
</script>

<style scoped lang="stylus">
	@import '~common/stylus/variable';
	.weui-article{
		padding-bottom 5px
		section{
			margin-bottom 0
		}
		p{
			font-size $article-p
			color $article-p-color
		}
	}
	.weui-cells{
		.weui-cell{
			padding 15px
		}
	}
	.weui-btn-area{
		margin-top 20px
		.weui-btn{
			width: 100%;
		}
	}
</style>
